import React from "react";

// import JS files

// import others files

const Header = (props) => {
  return (
    <>
      <div className="mt-16 md:mt-0 border-r-4 border-myblue-200 px-2">
        <span className="font-bold text-lg text-myblack-100">{props.header}</span>
      </div>
    </>
  );
};

export default Header;
